!<template>
  <div>
    <footer class="float-start w-100 footer-total-01">
      <div class="main-footer01 d-inline-block w-100 py-5">
        <div class="container">
          <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-6 g-5">
            <div class="col">
              <div class="comon-footer-mns d-inline-block w-100">
                <a href="#"
                   class="foot-logo">
                  <img src="../../assets/img/RayqeeLogoo.png"
                       alt="瑞启官网-logo">
                </a>
              </div>
            </div>

            <!-- #导航第1列 -->
            <div class="col">
              <div class="comon-footer-mns d-inline-block w-100">
                <h5>网站导航 </h5>

                <ul class="main-links mt-5">
                  <li class="d-flex align-items-center">
                    <a href="http://www.rayqee.com/">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="16"
                             height="16"
                             fill="currentColor"
                             class="bi bi-arrow-right-short"
                             viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                          </path>
                        </svg>
                      </span>
                      首页
                    </a>
                  </li>
                  <li>
                    <a href="http://www.rayqee.com/#AboutUs">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="16"
                             height="16"
                             fill="currentColor"
                             class="bi bi-arrow-right-short"
                             viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                          </path>
                        </svg>
                      </span>
                      关于我们
                    </a>
                  </li>
                  <li>
                    <a href="http://www.rayqee.com/#News">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="16"
                             height="16"
                             fill="currentColor"
                             class="bi bi-arrow-right-short"
                             viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                          </path>
                        </svg>
                      </span>
                      企业动态
                    </a>
                  </li>
                  <li>
                    <a href="http://www.rayqee.com/#FunctionFeature">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="16"
                             height="16"
                             fill="currentColor"
                             class="bi bi-arrow-right-short"
                             viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                          </path>
                        </svg>
                      </span>
                      功能亮点
                    </a>

                  </li>
                </ul>
              </div>
            </div>

            <!-- #导航第2列 -->
            <div class="col">
              <div class="comon-footer-mns d-inline-block w-100">
                <h5> &nbsp; </h5>

                <ul class="main-links mt-5">
                  <li class="d-flex align-items-center">
                    <a href="http://www.rayqee.com/#CooperatedPartner">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="16"
                             height="16"
                             fill="currentColor"
                             class="bi bi-arrow-right-short"
                             viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                          </path>
                        </svg>
                      </span>
                      合作伙伴
                    </a>
                  </li>
                  <li>
                    <a href="http://www.rayqee.com/articleList.html?type=CooperativeNews">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="16"
                             height="16"
                             fill="currentColor"
                             class="bi bi-arrow-right-short"
                             viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                          </path>
                        </svg>
                      </span>
                      合作新闻
                    </a>
                  </li>
                  <li>
                    <a href="http://www.rayqee.com/articleList.html?type=MediaNews">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="16"
                             height="16"
                             fill="currentColor"
                             class="bi bi-arrow-right-short"
                             viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                          </path>
                        </svg>
                      </span>
                      传媒资讯
                    </a>
                  </li>
                  <li>
                    <a href="http://www.rayqee.com/#JoinUs">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="16"
                             height="16"
                             fill="currentColor"
                             class="bi bi-arrow-right-short"
                             viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                          </path>
                        </svg>
                      </span>
                      加盟代理
                    </a>
                  </li>
                  <li>
                    <a href="http://www.rayqee.com//Source/creating/index.html">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="16"
                             height="16"
                             fill="currentColor"
                             class="bi bi-arrow-right-short"
                             viewbox="0 0 16 16">
                          <path fill-rule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                          </path>
                        </svg>
                      </span>
                      合作咨询
                    </a>
                  </li>

                </ul>
              </div>
            </div>

            <!-- #联系方式 -->
            <div class="col">
              <div class="comon-footer-mns d-inline-block w-100">
                <h5> 联系我们 </h5>
                <div class="foter-subcribe-div d-inline-block w-100 mt-5 text-white">
                  电话：0756-6181186
                </div>
                <div class="foter-subcribe-div d-inline-block w-100 mt-2 text-white">
                  邮箱：lion@eqlee.com
                </div>
                <div class="foter-subcribe-div d-inline-block w-100 mt-2 text-white">
                  地址：广东省珠海市香洲区双竹街82号广东珠海公共创业孵化基地105室
                </div>
              </div>
            </div>
            <!-- #关注瑞启自媒体 -->
            <div class="col-4">
              <div class="comon-footer-mns d-inline-block w-100">
                <h5> 关注瑞启自媒体 </h5>
                <div class="rq mt-5">
                  <a href="https://www.toutiao.com/c/user/token/MS4wLjABAAAABN4ejUij07RvzqSX4QzGAmOGv5wWmpoV82NI2V7HTOM/?source=m_redirect"
                     target="_blank">
                    <img src="../../assets/img/jinri.png"
                         alt="瑞启今日头条">
                    <span>瑞启今日头条</span>
                  </a>

                  <a href="https://m.weibo.cn/u/1763046612?featurecode=profile_qrcode&uid=1763046612&t=userinfo&_T_WM=8f1288c1bfb0ee3ea1d2bc9e8768ea3b"
                     target="_blank">
                    <img src="../../assets/img/weibo.png"
                         alt="瑞启微博">
                    <span>瑞启微博</span>
                  </a>
                  <a href="https://v.douyin.com/ik18Br7m/ 3@4.com :5pm"
                     target="_blank">
                    <img src="../../assets/img/douyin.png"
                         alt="瑞启抖音">
                    <span>瑞启抖音</span>
                  </a>
                  <a href="https://www.zhihu.com/people/89-94-34-55-81/asks"
                     target="_blank">
                    <img src="../../assets/img/zhihu.png"
                         alt="瑞启知乎">
                    <span>瑞启知乎</span>
                  </a>
                  <a href="https://www.xiaohongshu.com/user/profile/66e00924000000001b017bcc"
                     target="_blank">
                    <img src="../../assets/img/xiaohongshu.png"
                         alt="瑞启小红书">
                    <span>瑞启小红书</span>
                  </a>
                  <!-- <a href="#">
                <img src="../static/image/eqlee.png" alt="">
                <span>图片一</span>
              </a> -->
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  //import引入组件才能使用
  components: {},
  props: {},
  data () {
    return {

    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {},
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted () {

  },
  // 方法集合
  methods: {

  },
}
</script>
<style lang="less" scoped>
.w-100 {
  width: 100% !important;
}

.main-footer01 {
  background: url(../../assets/img/members_map_102.png) no-repeat;
  background-position: center top;
  padding-top: 71px !important;
  background-color: #11121c;
  padding-bottom: 71px !important;
  margin-top: 200px;
}
.col-4 {
  flex: 0 0 auto;
  width: 33.33333333% !important;
  padding: 0 16.5px;
}
.rq {
  display: flex;
  flex-wrap: wrap;
}
.rq a {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #7d7d7d;
  font-size: 12px;
  margin-right: 30px;
  margin-bottom: 10px;
  text-decoration: none !important;
}
.row {
  display: flex;
}
.container {
  color: #fff;
  max-width: 1320px;
  margin: 0 auto;
}
.mt-5 {
  margin-top: 3rem !important;
}
.row-cols-lg-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}
.main-footer01 .comon-footer-mns ul.main-links li {
  margin-bottom: 18px;
}
.main-footer01 .comon-footer-mns h5 {
  color: #fff;
  font-size: 23px;
  font-weight: 600;
}
.main-footer01 .comon-footer-mns ul.main-links li a {
  color: #d5d5dd;
  font-size: 15px;
  font-weight: 300;
  position: relative;
  outline: none !important;
  text-decoration: none !important;
}
.foter-subcribe-div {
  font-size: 15.4px;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.rq a img {
  width: 95px;
  height: 95px;
  margin-bottom: 10px;
}
</style>